<template>
  <div class="expand-indicator" :data-open="open">
    <PlaySVG/>
  </div>
</template>

<script>
import PlaySVG from "@/assets/play3.svg";

export default {
  name: "ExpandIndicator",
  components: {
    PlaySVG,
  },
  props: ["open"]
}
</script>

<style lang="scss" scoped>
  .expand-indicator {
    line-height: 1;
    font-size: 0.5em;
    transform-origin: center;

    &::v-deep svg, * {
      height: 1em;
      width: 1em;
    }

    &[data-open="true"] {
      transform: rotate(90deg);
    }
  }

</style>
